<template>
  <section id="tech" class="tech-ability animate-box">
    <div class="section-header">
      <div class="section-tag">CAPABILITIES</div>
      <h2>重塑<span>社区交互</span>新边界</h2>
    </div>
    <div class="ability-grid">
      <div class="ability-card" v-for="(item, index) in abilityList" :key="index">
        <div class="card-inner">
          <div class="card-icon">{{ item.icon }}</div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
const abilityList = [
  { icon: '✦', title: '智能分发', desc: '基于兴趣图谱的精准内容推送，让优质灵感不再被掩埋。' },
  { icon: '⚛', title: '虚拟协作', desc: '内置沉浸式在线协作空间，打破物理距离，随时同步思想。' },
  { icon: '🛡', title: '数字确权', desc: '利用区块链技术，为每一份社区贡献提供永久的价值追溯。' }
]
</script>

<style scoped>
.tech-ability {
  padding: 60px 10% 120px;
}

.ability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-top: 50px;
}

.ability-card {
  padding: 2px;
  border-radius: 15px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1), transparent);
  transition: 0.4s;
}

.card-inner {
  background: #0d0d0d;
  padding: 40px;
  border-radius: 13px;
  height: 100%;
}

.ability-card:hover {
  transform: translateY(-10px);
}

.card-icon {
  font-size: 2rem;
  color: var(--accent);
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .ability-grid {
    grid-template-columns: 1fr;
  }
}
</style>